import { render, staticRenderFns } from "./PortfolioUploadSection.vue?vue&type=template&id=de821850&scoped=true&"
import script from "./PortfolioUploadSection.vue?vue&type=script&lang=js&"
export * from "./PortfolioUploadSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de821850",
  null
  
)

export default component.exports